import React from 'react'
import { Setters } from 'src/features/brands/dxm/components'
import { OrderPageTemplate } from 'src/features/brands/components/OrderPageTemplate'
import { State, PartialAction } from 'src/types'
import { BaseModelSelector } from 'src/features/brands/components/BaseModelSelector/BaseModelSelector'
import { dxmModels as models } from 'src/features/brands/dxm/constants/baseModel'
import { catcherReducer, initialCatcherState } from 'src/features/brands/dxm/reducer/catcher'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/brands/dxm/constants/actionType'

const DxmCatcher: React.FC = () => {
  const [state, dispatch] = React.useReducer(catcherReducer, initialCatcherState) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  return (
    <OrderPageTemplate breadcrumbTrail={'硬式グラブ / DxM / 捕手用'} brand={'dxm'} {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}>
      <BaseModelSelector {...{ brand: 'dxm', state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default DxmCatcher
